import {
  OrgMemberRole,
  OrgMemberRoleAndPrivileges,
  PortalServiceSettingsAccessConsoleDto,
} from '@nx-frontend/shared/types';

export function hasUserAccessToPortal(role: OrgMemberRoleAndPrivileges, access: PortalServiceSettingsAccessConsoleDto) {
  const orgRole = role.role;
  if (access.guests && orgRole === OrgMemberRole.GUEST) {
    return true;
  }

  if (access.members && orgRole === OrgMemberRole.MEMBER) {
    return true;
  }

  if (access.managers && orgRole === OrgMemberRole.MANAGER) {
    return true;
  }
  if (access.owner && orgRole === OrgMemberRole.OWNER) {
    return true;
  }
  return false;
}
